import http from "../http-common";

class dataService {
  getAll( data ) {
    return http.post("/find", data );
  }

  get(id, table) {
    return http.get("/" + table + "/" + id);
  }

  create(data) {
    // If data has selectTable, wrap the rest in 'data' field
    const { selectTable, table, ...restData } = data;
    const tableName = selectTable || table;
    
    if (tableName) {
      return http.post("/one", {
        selectTable: tableName,
        data: restData
      });
    } else {
      return http.post("/one", data);
    }
  }

  bulkCreate(data) {
    return http.post("/many", data);
  }  

  update(data) {
    // If data has an 'id' field, transform to {selectTable, data: {...}, where: {id}}
    // Otherwise pass through as-is
    const { selectTable, table, id, ...restData } = data;
    const tableName = selectTable || table;
    
    if (id !== undefined) {
      return http.post("/update", {
        selectTable: tableName,
        data: restData,
        where: { id: id }
      });
    } else {
      return http.post("/update", data);
    }
  }

  delete(data) {
    // Transform {selectTable, id} to {selectTable, where: {id}}
    const { selectTable, table, id, ...restData } = data;
    const tableName = selectTable || table;
    
    if (id !== undefined) {
      return http.post("/delete", {
        selectTable: tableName,
        where: { id: id }
      });
    } else {
      return http.post("/delete", data);
    }
  }

  // User Account Management
  getUserAccount(userId) {
    return http.get("/user/" + userId);
  }

  saveUserAccount(data) {
    return http.post("/user", data);
  }

  // User Management (Magic Link Authentication)
  inviteUser(email, role, firstName, lastName) {
    return http.post("/users/invite", { email, role, firstName, lastName });
  }

  getAuthorizedUsers() {
    return http.get("/users/authorized");
  }

  resendInvite(email) {
    return http.post("/users/resend-invite", { email });
  }

  updateUserRole(email, role) {
    return http.put(`/users/${encodeURIComponent(email)}/role`, { role });
  }

  removeUser(email) {
    return http.delete(`/users/${encodeURIComponent(email)}`);
  }

  validateMagicLink(token) {
    return http.post("/users/auth/magic-link", { token });
  }

  validateSSOToken(token) {
    return http.post("/sso/validate", { token });
  }

  /**
   * Retroact Connect: exchange a partner launch assertion for a session.
   *
   * Separate from validateSSOToken because the two verify against different key
   * material and answer different shapes — this one also returns where to land
   * and which patient was matched. See retroact/backend/controllers/connect.controller.js.
   */
  validateConnectLaunch(token) {
    return http.post("/connect/launch", { token });
  }

  /** The partners this account may enable, and which are on. */
  getConnectConnections() {
    return http.get("/connect/connections");
  }

  enableConnectConnection(clientId, externalOrgId) {
    return http.post(`/connect/connections/${encodeURIComponent(clientId)}`, { externalOrgId });
  }

  revokeConnectConnection(clientId) {
    return http.delete(`/connect/connections/${encodeURIComponent(clientId)}`);
  }

  // Notes
  findNote(patientId, elementType, elementId) {
    return http.get(`/notes/find?patientId=${patientId}&elementType=${encodeURIComponent(elementType)}&elementId=${encodeURIComponent(elementId)}`);
  }

  getAllNotes(patientId) {
    return http.get(`/notes?patientId=${patientId}`);
  }

  createNote(data) {
    return http.post("/notes", data);
  }

  updateNoteById(id, data) {
    return http.put(`/notes/${id}`, data);
  }

  deleteNoteById(id) {
    return http.delete(`/notes/${id}`);
  }

  // Git Commits
  getGitCommits() {
    return http.get("/git/commits");
  }

  // Dose Management
  batchCreateDoses(doses) {
    return this.bulkCreate({
      selectTable: 'daily_doses',
      data: doses
    });
  }

  createSingleDose(dose) {
    return this.create({
      selectTable: 'single_doses',
      ...dose
    });
  }

  updateResult(resultId, data) {
    return this.update({
      selectTable: 'results',
      id: resultId,
      ...data
    });
  }

/*   deleteAll(table) {
    return http.delete("/" + table);
  } */

/*   findByName(name) {
    return http.get(`/patients?name=${name}`);
  } */
}

export default new dataService();